import styled from "styled-components";
import {
	COLOR_TEXT_PRIMARY_B2C,
	MOBILE_L_BP,
	FONT_WT_MEDIUM,
	TABLET_BP,
	DESKTOP_SM_BP,
	DESKTOP_M_BP,
	COLOR_WHITE,
} from "@website-builder/utilities-index";

export const GuideWrapper = styled.div`
	padding: 60px 0;
	.container {
		display: flex;
		justify-content: center;
		align-items: flex-start;
		padding: 10px 0;
		margin: 0 auto;
	}
	.imageWrapper {
		margin-right: 50px;
		img {
			width: 371px;
		}
	}
	.contentWrapper {
		margin-left: 50px;
		margin-top: auto;
		margin-bottom: auto;
		.header {
			font-size: 28px;
			font-weight: ${FONT_WT_MEDIUM};
			line-height: 32px;
			color: ${COLOR_TEXT_PRIMARY_B2C};
			margin-bottom: 40px;
		}
		img {
			margin-right: 15px;
			margin-top: 3px;
		}
		div {
			div {
				margin-bottom: 20px;
				line-height: 26px;
				:last-child {
					margin-bottom: 0px;
				}
			}
		}
		width: 540px;
		.form {
			width: 540px;
			margin-top: 40px;
			.formContainer {
				display: flex;
				.formControl {
					max-width: 540px;
					margin-bottom: 10px;
				}
				.name {
					width: 172px;
					margin-right: 9px;
				}
				.email {
					width: 359px;
				}
			}
			.submitButton {
				width: 540px;
			}
			.errorMessage {
				margin-bottom: 5px;
				font-size: 16px;
				font-weight: ${FONT_WT_MEDIUM};
				color: ${COLOR_WHITE};
			}
		}
		.successMessage {
			margin-top: 40px;
			color: ${COLOR_TEXT_PRIMARY_B2C};
		}
	}

	@media only screen and (max-width: ${DESKTOP_M_BP}px) {
		.imageWrapper {
			margin-right: 25px;
		}
		.contentWrapper {
			margin-left: 25px;
		}
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		padding: 35px 30px;
		h5 {
			font-size: 26px;
			margin: 0 0 30px 0;
		}
		.container {
			flex-direction: column;
			.contentWrapper {
				width: 100%;
				margin-top: 50px !important;
				.formContainer {
					justify-content: center;
				}
				.form {
					width: unset;
					text-align: center;
					margin-left: auto;
					margin-right: auto;
					.name {
						width: 172px;
						margin-right: 9px;
					}
					.email {
						width: 359px;
					}
				}
				.successMessage {
					text-align: center;
				}
			}
			.imageWrapper {
				width: 100%;
			}
		}
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) and (min-width: ${TABLET_BP}px) {
		.container {
			flex-wrap: wrap;
			.contentWrapper {
				width: 100%;
				margin: 0 auto 80px 0;
			}
		}
		.imageWrapper {
			text-align: center;
		}
	}

	@media only screen and (max-width: ${TABLET_BP - 1}px) {
		padding: 35px 20px;
		.contentWrapper {
			.header {
				font-size: 24px;
			}
			margin: 0 auto 50px 0;
			.form {
				.submitButton {
					width: 100%;
				}
				.formContainer {
					display: block;
					.name {
						width: 100%;
						max-width: unset;
					}
					.email {
						width: 100%;
						max-width: unset;
					}
				}
			}
		}
		.imageWrapper {
			text-align: center;
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		.imageWrapper {
			.imageContainer {
				img {
					width: 100%;
					padding: 0 40px;
				}
			}
		}
	}
`;
